import { isLandscape, isVideo } from '@libs/NwUtils';

import {
    formatPages,
    getPlaceholderPictureForBook,
} from './PlaylistEditorUtils';
import { arrayMove } from '@dnd-kit/sortable';

const playlistEditorReducer = (state, action) => {
    const isSinglePage = state.singlePage;

    switch (action.type) {
        case 'SetBookToEdit':
            return {
                ...state,
                bookToEdit: action.value,
            };
        case 'BookToEditData':
            return {
                ...state,
                bookToEditData: action.value,
            };
        case 'ChangeMediaTypeToDisplay':
            return {
                ...state,
                mediaTypeToDisplay: action.value,
            };
        case 'ToggleHideUsedPictures':
            return {
                ...state,
                hideUsedPictures: action.value,
            };
        case 'ToggleExtendedFilters':
            return {
                ...state,
                extendedFilters: action.value,
            };
        case 'ToggleSinglePage':
            const playlistItemsReArranged = formatPages(
                state.playlistItems,
                action.value
            );
            return {
                ...state,
                playlistItems: [...playlistItemsReArranged],
                singlePage: action.value,
            };
        case 'FillDocumentsList':
            return {
                ...state,
                documentsList: action.value,
            };
        case 'SetActiveId':
            return {
                ...state,
                activeId: action.value,
            };
        case 'SetActiveItem':
            return {
                ...state,
                activeItem: action.value,
            };
        case 'SetIsFetchingDocuments':
            return {
                ...state,
                isFetchingDocuments: action.value,
            };
        case 'SetPlaylistItems':
            return {
                ...state,
                playlistItems: [...action.value],
            };
        case 'AddPlaylistItem':
            let newItem = null;
            if (action.placeholder) {
                newItem = getPlaceholderPictureForBook();
            } else {
                newItem = {
                    ID: action.value.ID,
                    page: null,
                    media: action.value.media,
                    isLandscape: isLandscape(action.value.media),
                    isVideo: isVideo(action.value.media),
                };
            }
            const newPlaylistItems = [...state.playlistItems, newItem];
            const newPlaylistItemsWithPages = formatPages(
                newPlaylistItems,
                isSinglePage
            );
            return {
                ...state,
                playlistItems: [...newPlaylistItemsWithPages],
            };
        case 'AddPlaylistItems':
            // Aggiunge in coda un blocco di media e impagina una volta sola:
            // la selezione mobile arriva sempre come batch ordinato.
            const appendedItems = action.value.map((entry) =>
                entry.placeholder
                    ? getPlaceholderPictureForBook()
                    : {
                          ID: entry.media.ID,
                          page: null,
                          media: entry.media,
                          isLandscape: isLandscape(entry.media),
                          isVideo: isVideo(entry.media),
                      }
            );
            const playlistItemsWithBatch = formatPages(
                [...state.playlistItems, ...appendedItems],
                isSinglePage
            );
            return {
                ...state,
                playlistItems: [...playlistItemsWithBatch],
            };

        case 'AddPlaylistItemIndex':
            let newItemWithIndex = null;
            if (action.placeholder) {
                newItemWithIndex = getPlaceholderPictureForBook();
            } else {
                newItemWithIndex = {
                    ID: action.value.ID,
                    page: null,
                    media: action.value.media,
                    isLandscape: isLandscape(action.value.media),
                    isVideo: isVideo(action.value.media),
                };
            }
            const newPlaylistItemsIndex = [
                ...state.playlistItems.slice(0, action.value.index),
                newItemWithIndex,
                ...state.playlistItems.slice(action.value.index),
            ];
            const newPlaylistItemsIndexWithPages = formatPages(
                newPlaylistItemsIndex,
                isSinglePage
            );
            return {
                ...state,
                playlistItems: [...newPlaylistItemsIndexWithPages],
            };

        case 'RemovePlaylistItem':
            const playlistItemsAfterRemoval = state.playlistItems.filter(
                (item) => item.ID !== action.value
            );
            const playlistItemsAfterRemovalWithPages = formatPages(
                playlistItemsAfterRemoval,
                isSinglePage
            );
            return {
                ...state,
                playlistItems: [...playlistItemsAfterRemovalWithPages],
            };

        case 'MovePlaylistItem':
            const playlistItemsAfterMove = arrayMove(
                state.playlistItems,
                action.value.oldIndex,
                action.value.newIndex
            );
            const playlistItemsAfterMoveWithPages = formatPages(
                playlistItemsAfterMove,
                isSinglePage
            );
            return {
                ...state,
                playlistItems: [...playlistItemsAfterMoveWithPages],
            };

        case 'ClearPlaylist':
            return {
                ...state,
                playlistItems: [],
            };

        case 'SetPreviewVideo':
            return {
                ...state,
                previewVideo: action.value,
            };

        default:
            return state;
    }
};

export default playlistEditorReducer;
